import { render, staticRenderFns } from "./budgetView.vue?vue&type=template&id=4155abbe&"
import script from "./budgetView.vue?vue&type=script&lang=js&"
export * from "./budgetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports